exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".mark-multiple-short-channels-orders-invoiced-modal .modal-container {\n  max-width: 600px;\n  width: auto;\n}", ""]);

// exports
